import { FC } from 'react';
import { useRegistrationMode } from '@/hooks/registration/useRegistrationMode';
import { Paper, Stack, Typography, FormControlLabel, Switch } from '@mui/material';
import { useTranslation } from 'react-i18next';
import RegistrationModeDrawer from '@/components/registration/registrationMode/RegistrationModeDrawer';

type RegistrationModeDrawerProps = {
    compact?: boolean;
};

const RegistrationModeCard: FC<RegistrationModeDrawerProps> = () => {
    const { t } = useTranslation('common');
    const { state, isInstallationMode, confirmMessage, openConfirmDialog, closeConfirmDialog, confirmModeChange } =
        useRegistrationMode();

    return (
        <>
            <Paper
                elevation={0}
                sx={{
                    borderRadius: 3,
                    border: '2px solid #BFDBFE',
                    bgcolor: '#EFF6FF',
                    px: 1.5,
                    py: 1,
                }}
            >
                <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
                    <Typography
                        variant="subtitle1"
                        sx={{
                            fontSize: 14,
                            lineHeight: 1.2,
                            fontWeight: 800,
                        }}
                    >
                        {isInstallationMode ? t('Installation Mode') : t('Normal Mode')}
                    </Typography>

                    <FormControlLabel
                        sx={{
                            m: 0,
                            '.MuiFormControlLabel-label': {
                                fontSize: 14,
                                minWidth: 28,
                                fontWeight: 800,
                                color: isInstallationMode ? '#0B5BD3' : '#64748B',
                            },
                            '.MuiSwitch-root': {
                                width: 46,
                                height: 28,
                                p: 0.5,
                            },
                            '.MuiSwitch-switchBase': {
                                p: '5px',
                                '&.Mui-checked': {
                                    transform: 'translateX(18px)',
                                },
                            },
                            '.MuiSwitch-thumb': {
                                width: 18,
                                height: 18,
                            },
                            '.MuiSwitch-track': {
                                borderRadius: 999,
                            },
                        }}
                        control={<Switch checked={isInstallationMode} onChange={openConfirmDialog} />}
                        label={isInstallationMode ? t('ON') : t('OFF')}
                        labelPlacement="start"
                    />
                </Stack>
            </Paper>
            <RegistrationModeDrawer
                open={state.dialogState.isStoreStateOpen}
                onConfirm={confirmModeChange}
                onClose={closeConfirmDialog}
                confirmMessage={confirmMessage}
            />
        </>
    );
};

export default RegistrationModeCard;
